import React, { Component } from 'react';
import { CellType } from './OnlineEnums';

export class OnlineGameCard extends Component {

  constructor(props) {
      super(props);
  }

  render() {
      return (
          <div>
              {this.getButtonContent(this.getContentByStatus())}
          </div>
      );
    }

    getContentByStatus() {
        if (this.props.showGuessConfirmation)
            return this.getSelectingColorContent();
        return this.getCardUnselectedContent();
    }

    getCardUnselectedContent() {
        return (
            <table className={"gamecard" + this.getCardTableClass()}>
                <tbody>
                    <tr><td className={"theirCard cardpart" + this.getWordHalfStatusThem() + this.getWordClass()}>
                        {this.props.word}
                    </td></tr>
                    <tr><td className={"cardpart" + this.getWordHalfStatusUs() + this.getWordClass()}>
                        {this.props.word}
                    </td></tr>
                </tbody>
            </table>);
    }

    getWordClass() {
        if (this.props.word.length > 8)
            return " smalltext";
        return "";
    }

    getCardTableClass() {
        switch (this.props.visibleUs) {
            case CellType.Green:
                if (this.props.dimGuessedCards)
                    return " lightgreencard";
                else
                    return " greencard";
            case CellType.Black: return " blackcard";
        }

        return "";
    }

    getWordHalfStatusUs() {
        if (this.props.visibleUs === CellType.Yellow)
            return " yellowcard";
        //if(this.props.)
        return "";
    }

    getWordHalfStatusThem() {
        if (this.props.visibleThem === CellType.Green)
            return "";

        var cellType = this.props.visibleCellUsOverride;
        if (cellType == null)
            cellType = this.props.visibleThem;

        switch (cellType) {
            case CellType.Yellow: return " yellowcard";
            case CellType.Green: return " greencard";
            case CellType.Black: return " blackcard";
            default: return "";
        }
    }

    getSelectingColorContent() {
        return (
            <table className="cardColorSelect">
                <tbody>
                    <tr className="cardColorSelect">
                        <td className="cardColorSelect"><button className="btn cardColorSelectButton blackcard" onClick={async () => await this.confirmGuess()}></button></td>
                        <td className="cardColorSelect"><button className="btn cardColorSelectButton greencard" onClick={async () => await this.confirmGuess()}></button></td>
                        <td className="cardColorSelect"><button className="btn cardColorSelectButton yellowcard" onClick={async () => await this.confirmGuess()}></button></td>
                    </tr>
                </tbody>
            </table>
            );
    }

    async confirmGuess() {
        if (!this.props.isWaitingForActionFromUs)
            return;

        await this.props.confirmGuessFunc();
    }

    async makeGuess() {
        if (!this.props.isClickable)
            return;
        await this.props.makeGuessFunc(this.props.index);
    }

    getButtonContent(fixedContent) {
        if (this.props.isClickable) {
            return (
                <button className="btn activeCardButton" onClick={async () => await this.makeGuess()}>
                    {fixedContent}
                </button >
            );
        }

        return fixedContent;
    }
}
